export default __webpack_public_path__ + "static/media/m240.098a5e09.jpg";